<template>
  <div class="qualification-type">
    <van-nav-bar
      title="选择资质类型"
      left-arrow
      fixed
      placeholder
      @click-left="$router.go(-1)"
    />
    <div style="padding: 15px">
      <van-radio-group v-model="form.qualificationType">
        <div>
          <div class="title-row">
            <el-image
              class="icon"
              :src="
                require('@/assets/images/simulation/icon_qualification1.png')
              "
              fit="cover"
            ></el-image>
            <span>绑定资质</span>
          </div>

          <div class="radio-item">
            <van-cell
              clickable
              center
              @click="form.qualificationType = '我是抖店商家'"
            >
              <template #title>
                <p class="custom-title">我是抖店商家</p>
                <p class="title-tips">
                  已有开通的小店，建议直接选择“资质绑定”，若选择其他方式升级结算账户，<span
                    >该抖音账号将无法再和店铺进行绑定</span
                  >
                </p>
              </template>
              <template #right-icon>
                <van-radio
                  name="我是抖店商家"
                  checked-color="#ee0a24"
                  icon-size="16px"
                />
              </template>
            </van-cell>
          </div>
        </div>

        <div>
          <div class="title-row">
            <el-image
              class="icon"
              :src="
                require('@/assets/images/simulation/icon_qualification2.png')
              "
              fit="cover"
            ></el-image>
            <span>绑定开通</span>
          </div>

          <p class="tips-row">
            <i class="el-icon-warning-outline" style="font-weight: bold"></i>
            请选择带货资质，不同的资质将影响你的带货收入上限
          </p>

          <div class="radio-item">
            <van-cell clickable center @click="form.qualificationType = '个人'">
              <template #title>
                <p class="custom-title">个人</p>
                <p class="title-tips">
                  账号为个人所有，请准备身份证、个人银行卡
                </p>
              </template>
              <template #right-icon>
                <van-radio
                  name="个人"
                  checked-color="#ee0a24"
                  icon-size="16px"
                />
              </template>
            </van-cell>
          </div>

          <div class="radio-item">
            <van-cell clickable center>
              <template #title>
                <p class="custom-title">个体工商户</p>
                <p class="title-tips">
                  请准备个体工商执照、经营者证件、个人或企业银行卡
                </p>
              </template>
              <template #right-icon>
                <van-radio
                  name="个体工商户"
                  checked-color="#ee0a24"
                  icon-size="16px"
                  disabled
                />
              </template>
            </van-cell>
          </div>

          <div class="radio-item">
            <van-cell clickable center>
              <template #title>
                <p class="custom-title">企业</p>
                <p class="title-tips">
                  企业号、政务号、媒体号或账号为公司所有，请准备营业执照、法人证件、对公账户
                </p>
              </template>
              <template #right-icon>
                <van-radio
                  name="企业"
                  checked-color="#ee0a24"
                  icon-size="16px"
                  disabled
                />
              </template>
            </van-cell>
          </div>
        </div>
      </van-radio-group>

      <p class="tips">
        <i class="el-icon-bell" style="font-weight: bold"></i>
        以「个人」或「个体工商户」资质完成认证，后续带货收入达到一定量级时，需升级至「个体工商户」或「企业」资质。
      </p>

      <div
        class="btn"
        :class="{ disabled: !form.qualificationType }"
        @click="handleNext"
      >
        下一步
      </div>
    </div>
  </div>
</template>

<script>
import "vant/lib/index.css";
import { NavBar, Cell, Radio, RadioGroup, Dialog } from "vant";
export default {
  props: {
    form: Object,
  },
  components: {
    [NavBar.name]: NavBar,
    [Cell.name]: Cell,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
  },
  methods: {
    handleNext() {
      if (this.form.qualificationType) {
        if (this.form.qualificationType == "我是抖店商家")
          this.$router.push("/simulation/douyinchuchuang/qualificationBinding");
        else {
          Dialog.confirm({
            title: "账号身份认证说明",
            message:
              "你正在进行巨量百应及精选联盟账号的身份认证，你提供相关身份认证资料完成认证，即表明你知晓并同意：1、如你后续使用绑定的抖音账号登录小店平台，申请开店，也仅可用该身份信息去小店平台完成认证，你授权平台将你认证资料及信息提供给小店平台。\n 2、巨量百应平台及精选联盟平台，个人用户仅能注册认证一个帐号。\n3、佣金等带货相关收入将仅能结算到帐号认证主体的相关账户，认证信息除符合平台规则外，不允许变更。\n 提示：\n 1、如你已有开通的小店，建议你直接选择“资质绑定”，使用你店铺资质完成认证。否则将可能导致你的帐号无法再与你的店铺进行绑定。\n 2、如对身份认证有任何疑问可以联系平台客服进行咨询。",
            messageAlign: "left",
            width: "280px",
            className: "confirm-dialog",
            confirmButtonColor: "#000",
            cancelButtonColor: "#606266",
            getContainer: () => {
              return document.querySelector(".qualification-type");
            },
          })
            .then(() => {
              this.$router.replace('/simulation/douyinchuchuang/confirmPage')
            })
            .catch(() => {
              // on cancel
            });
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.qualification-type {
  .title-row {
    margin-bottom: 10px;
    font-weight: bold;
    .icon {
      margin-right: 5px;
      vertical-align: middle;
    }
  }
  .tips-row {
    padding: 8px;
    margin-bottom: 10px;
    font-size: 12px;
    color: #f88800;
    background-color: #f9f2ea;
  }
  .radio-item {
    margin-bottom: 15px;
    border-radius: 3px;
    overflow: hidden;
    .custom-title {
      padding-top: 10px;
      margin-bottom: 5px;
      font-size: 16px;
      color: #303133;
    }
    .title-tips {
      width: 90%;
      color: #909399;
      font-size: 12px;
      span {
        color: #303133;
      }
    }
  }
  .tips {
    margin-left: 5px;
    color: #efc548;
    font-size: 12px;
  }
  .btn {
    margin-top: 15px;
    padding: 10px 0;
    text-align: center;
    color: #fff;
    background-color: #e21e48;
    border-radius: 3px;
    user-select: none;
    cursor: pointer;
    &.disabled {
      opacity: 0.4;
      cursor: not-allowed;
    }
  }
  ::v-deep .confirm-dialog {
    border-radius: 0;
    .van-dialog__message {
      &::-webkit-scrollbar {
        width: 0 !important;
      }
    }
  }
}
</style>